import clsx from 'clsx';
import dayjs from 'dayjs';

export default function DayCell({
  date,
  employee,
  onAddShift,
  onRemoveShift,
  minRequired,
  shifts = [],
  employeesScheduled = 0,
  offMap,
}) {
  const shortage  = employeesScheduled < minRequired;
  const leaveType = offMap[`${employee.id}-${date.format('YYYY-MM-DD')}`];
  const isPast    = date.isBefore(dayjs(), 'day');
  const isOnLeave = Boolean(leaveType);

  /* ---------- cell content ---------- */
  let content;
  if (leaveType === 'SICK') {
    content = (
      <span className="text-[11px] leading-tight rounded bg-orange-50 px-1 py-0.5">
        🤒 Sick
      </span>
    );
  } else if (leaveType === 'TIME_OFF') {
    content = (
      <span className="text-[11px] leading-tight rounded bg-teal-50 px-1 py-0.5">
        🌴 Off
      </span>
    );
  } else if (shifts.length) {
    content = (
      <div className="space-y-0.5 w-full">
        {shifts.map((s, idx) => (
          <div
            key={idx}
            className="relative text-[11px] leading-tight rounded border-l-4 bg-indigo-50 px-1 py-0.5"
            style={{ borderColor: '#6366f1' }}
          >
            <span>{s.start}-{s.end}{s.role ? ` · ${s.role}` : ''}</span>
            {s.breaks && s.breaks.length > 0 && (
              <span className="block text-[10px] leading-tight text-gray-600">
                Break: {s.breaks.map(b => `${b.start}-${b.end}`).join(', ')}
              </span>
            )}

            {/* tiny delete button – stops the click bubbling so the add-modal */}
            {onRemoveShift && (
              <button
                type="button"
                aria-label="Delete shift"
                onClick={(e) => { e.stopPropagation(); onRemoveShift(idx); }}
                className="absolute -top-1 -right-1 w-4 h-4 rounded-full text-[10px] leading-none bg-red-500 text-white hover:bg-red-600"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
    );
  } else {
    content = <span className="text-gray-400 text-xs">—</span>;
  }

  return (
    <button
      disabled={isPast || isOnLeave}
      onClick={onAddShift}
      className={clsx(
        'relative border-l border-b h-16 w-full flex items-center justify-center focus:outline-none',
        isOnLeave            && 'bg-orange-100 cursor-not-allowed',
        isPast && !isOnLeave && 'cursor-not-allowed opacity-40',
       )}
    >
      {content}
    </button>
  );
}
